import React from 'react';

import { startCase } from 'lodash';
import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/breeds';

const ListRaces = () => {
  const filter = {};

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'creator.name', label: 'Creator' },
          { value: 'stallion.name', label: 'Stallion' },
          { value: 'stallion.bloodline', label: 'BloodLine' },
        ],
        api,
        sort: { createdAt: -1 },
        filter,
        actions: {
          create: false,
          delete: false,
          fileExport: true,
        },
        cols: [
          { key: 'creator.name', children: 'Creator', sortable: true },
          { key: 'stallion.name', children: 'Stallion', sortable: true },
          { key: 'stallion.bloodline', children: 'BloodLine', sortable: true },
          { key: 'player.name', children: 'Player', sortable: true },
          { key: 'mare.name', children: 'Mare', sortable: true },
          { key: 'mare.bloodline', children: 'BloodLine', sortable: true },
          { key: 'price', sortable: true, getter: (v) => v && v / 10 ** 9 },
          { key: 'status', sortable: true, getter: (v) => startCase(v) },
          { key: 'createdAt', sortable: true },
          { key: 'updatedAt', sortable: true },
        ],
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
      )}
    </ListResource>
  );
};

export default ListRaces;
